// The initial number of years queried when searching for test results
// see: /u/health-record/test-results
export const INIT_YEARS_TO_QUERY = 5;

// The maximum number of years that can be queried when searching for test results
// see: /u/health-record/test-results
export const MAX_YEARS_TO_QUERY = 50;

// The default error message used when an error when an error is present but no message is available
// while viewing a test result's details.
// see: /u/health-record/test-results/{test result id}
export const FALLBACK_TEST_RESULT_ERROR_MESSAGE = 'An error occurred retrieving the test results';

export const TEST_RESULT_BANNER_DISCLAIMER = `You may be seeing your results before your provider has reviewed them. These test results
could include sensitive information. If you have any questions about your result contact
the ordering provider for interpretation. Do not change or adjust treatment plan, always
follow your providers instruction until further advised.`;

export const DEFAULT_MICROBIOLOGY_HISTORICAL_NAME = 'Microbiology result';
